module.exports = __webpack_public_path__ + "img/flip-4.c7ee1861.png";